module.exports = __webpack_public_path__ + "img/ssp.49489359.svg";